// Controller
import mapController from '../controllers/MapControllers';

// Store
import { LEVEL_ALL, LevelSelectedType } from '../store/slices/admin2EstimatesSlice';

// Configs
import { ADMIN1_REGION_ID_FIELD, DHSREGEN } from '../configs/map.configs';

export function getAdmin1DefinitionExpressionValue(levelSelected: LevelSelectedType) {
  return levelSelected.level !== LEVEL_ALL.level
    ? `${ADMIN1_REGION_ID_FIELD} = '${levelSelected.admin1RegionID}'`
    : '1=1';
}

export const updateAdmin1ClientSideFeaturesLayerDefinitionExpression = (levelSelected: LevelSelectedType) => {
  if (mapController.admin1ClientSideFeaturesLayer) {
    const admin1definitionExpressionValue = getAdmin1DefinitionExpressionValue(levelSelected);
    mapController.admin1ClientSideFeaturesLayer.definitionExpression = admin1definitionExpressionValue;
  }
};

export function getAdmin2DefinitionExpressionValue(levelSelected: LevelSelectedType) {
  if (levelSelected.level !== LEVEL_ALL.level) {
    return `region_id = '${levelSelected.admin1RegionID}'`;
  } else {
    return '1=1';
  }
}

export const updateAdmin2ClientSideFeaturesLayerDefinitionExpression = (levelSelected: LevelSelectedType) => {
  if (mapController.admin2ClientSideFeaturesLayer) {
    const admin2definitionExpressionValue = getAdmin2DefinitionExpressionValue(levelSelected);
    mapController.admin2ClientSideFeaturesLayer.definitionExpression = admin2definitionExpressionValue;
  }
};
